import {
  CSV_DATA_FAILURE,
  CSV_DATA_SUCCESS,
  CSV_UPLOAD_FAILURE,
  CSV_UPLOAD_SUCCESS,
  DEACTIVATE_USER_FAILURE,
  DEACTIVATE_USER_SUCCESS,
  REACTIVATE_USER_FAILURE,
  REACTIVATE_USER_SUCCESS,
  REPORT_FAILURE,
  REPORT_SUCCESS,
} from "./people.actionTypes";

const initialState = {
  csvData: [],
  reActivatedUser: null,
  deActivatedUser: null,
  adminReport: null,
};

export default function peopleReducer(state = initialState, { type, payload }) {
  switch (type) {
    case CSV_DATA_SUCCESS:
      return {
        ...state,
        csvData: payload,
      };
    case CSV_DATA_FAILURE:
      return {
        ...state,
        message: "",
      };

    case REACTIVATE_USER_SUCCESS:
      return {
        ...state,
        csvData: payload,
      };
    case REACTIVATE_USER_FAILURE:
      return {
        ...state,
        message: "",
      };

    case DEACTIVATE_USER_SUCCESS:
      return {
        ...state,
        csvData: payload,
      };
    case DEACTIVATE_USER_FAILURE:
      return {
        ...state,
        message: "",
      };

    case REPORT_SUCCESS:
      return {
        ...state,
        adminReport: payload,
      };
    case REPORT_FAILURE:
      return {
        ...state,
        message: "",
      };

    default:
      return state;
  }
}
